import React from 'react';
import { Cell } from 'react-table';

import { formatNumberCompact } from '@trqk/utils';

interface GapCellProps {
    cell: Cell<TrqkGapChannel, number>;
}

/**
 * Formats a gap into a compact string centered within a div. For example, given the input `1000`,
 * the output would be '1K'.
 * @param props - {@link GapCellProps}
 */
export function GapCell({ cell }: GapCellProps): JSX.Element {
    const { value } = cell;

    return (
        <div className="flex items-center justify-center">
            {formatNumberCompact(value)}
        </div>
    );
}
